export const salesArabicTranslations: Record<string,string> = {
  'Course plan saved for this month only. Other months are independent.': 'خطة الكورسات اتحفظت للشهر ده فقط. باقي الشهور مستقلة.',
  'Employee allocation saved for this month only. Other months are independent.': 'توزيع الموظف اتحفظ للشهر ده فقط. باقي الشهور مستقلة.',
  'Each month has a separate course plan and employee allocations. No automatic carry-over.': 'كل شهر ليه خطة كورسات وتوزيعات موظفين مستقلة، من غير ترحيل تلقائي.',
  'Prepare assignment': 'جهّز التوزيع',
  'Search results changed. Refresh and select the leads again.': 'نتايج البحث اتغيّرت. حدّث الصفحة واختار العملاء تاني.',
  'Search navigation': 'دوّر في القائمة',
  'Clear navigation search': 'امسح بحث القائمة',
  'No matching pages': 'مفيش صفحات بالاسم ده',
  'Workspace': 'مساحة الشغل',
  'Sales Operations': 'عمليات السيلز',
  'General Manager': 'المدير العام',
  'Team Leader': 'التيم ليدر',
  'Sales navigation': 'تنقل السيلز',
  'Mobile navigation': 'التنقل على الموبايل',
  'Sales tools': 'أدوات السيلز',
  'Team & Targets': 'الفريق والتارجت',
  'Menu': 'القائمة',
  'My work': 'شغلي',
  'Save changes': 'حفظ التغييرات',
  'Showing {0} of {1}': 'عرض {0} من {1}',
  'Work: {0}': 'الشغل: {0}',
  'Queue: {0}': 'المواعيد: {0}',
  'Lead scope: {0}': 'الليدات: {0}',
  'Lost reason is required.': 'سبب فقدان الليد مطلوب.',
  'Proposal notes is required.': 'ملاحظات العرض مطلوبة.',
  'Objection / requested change is required.': 'الاعتراض أو التغيير المطلوب لازم يتكتب.',
  'Interest note is required.': 'ملاحظة الاهتمام مطلوبة.',
  'Edit Lead Details': 'تعديل بيانات الليد',
  'Facebook': 'فيسبوك',
  'Website': 'الموقع',
  'Landing Page': 'صفحة الإعلان',
  'Facebook Sheet': 'شيت فيسبوك',
  'B2B': 'شركات',
  '🔥 Hot': '🔥 مهتم جدًا',
  '⚡ Warm': '⚡ مهتم',
  '❄️ Cold': '❄️ اهتمامه قليل',
  'Lead outside my specialization': 'الليد خارج تخصصي',
  'Too many leads / workload issue': 'عدد الليدات كبير أو ضغط شغل',
  'Language issue': 'مشكلة في اللغة',
  'Complaint / conflict': 'شكوى أو خلاف',
  'Duplicate suspected': 'غالبًا ليد مكرر',
  'Pricing issue': 'مشكلة في السعر',
  'Course not clear': 'الكورس مش واضح',
  'Payment issue': 'مشكلة في الدفع',
  'Sales help': 'مساعدة السيلز',
  'New': 'جديد',
  'Not saved yet': 'لسه متحفظش',
  'Lost': 'خسرناه',
  'Sort: {0}': 'الترتيب: {0}',
  'Course plan saved. Following months inherit it until another month is changed.': 'خطة الكورسات اتحفظت. الشهور اللي جاية هتمشي عليها لحد ما تغيّر خطة شهر تاني.',
  'Employee allocation saved. Following months inherit this allocation.': 'توزيع الموظف اتحفظ. الشهور اللي جاية هتمشي على نفس التوزيع.',
  'Rules saved. Effective {0}.': 'قواعد العمولة اتحفظت. هتبدأ من {0}.',
  'Each achievement threshold must be different.': 'كل نسبة تحقيق لازم تكون مختلفة عن التانية.',
  '{0}% achieved → {1}% commission': 'تحقيق {0}% ← عمولة {1}%',
};
export const salesEnglishTranslations: Record<string,string> = {};
